import script from "./LineStylePanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./LineStylePanel.vue?vue&type=script&lang=ts&setup=true"

import "./LineStylePanel.vue?vue&type=style&index=0&id=72b9a6ae&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72b9a6ae"]])

export default __exports__